module.exports = __webpack_public_path__ + "img/laptop-slash.91445cc6.svg";